export enum Recipient {
  ME = 'Me',
  OTHERS = 'Others'
}
